import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DynamicTablePaginatorEvent } from './dynamic-table-paginator-event';

@Injectable({
  providedIn: 'root'
})
export class DynamicTablePaginatorService {

  private status: BehaviorSubject<DynamicTablePaginatorEvent> = new BehaviorSubject<DynamicTablePaginatorEvent>({
    currentPage: 1,
    itemsPerPage: 30
  });

  constructor() { }

  public change(data: DynamicTablePaginatorEvent) {
    this.status.next(data);
  }

  public onChange(): Observable<DynamicTablePaginatorEvent> {
    return this.status.asObservable();
  }

}
